import {
  Component,
  OnInit,
  forwardRef,
  Input,
  EventEmitter,
  Output
  } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { BaseControlValueAccessor } from '../base-control-value-accessor';
import { MbscCalendarOptions } from 'src/lib/mobiscroll/js/mobiscroll';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateTimePickerComponent),
      multi: true
    }
  ]
})
export class DateTimePickerComponent  extends BaseControlValueAccessor<string>  implements OnInit {

  @Input() formControl: FormControl;
  @Input() text: string;
  @Input() config: any;

  @Output() changeCallback = new EventEmitter();

  public settings: any;
  public date: any;
  desktopSettings: MbscCalendarOptions;


  constructor(private utilService: UtilService) {
    super();
  }

  ngOnInit() {
    this.desktopSettings = {
      controls: ['calendar', 'time'],
      touchUi: true,
      onSet: this.onInputChange,
      dateFormat: 'dd/mm/yy',
      timeFormat: 'HH:ii:ss'
  };
    if (this.formControl && this.formControl.value) {
      this.date = this.formControl.value;
    }
  }

  onInputChange = (): void => {
    this.date = this.utilService.convertMomentToDateTimeStringinDotFormat(this.date);
    this.onChange(this.date);
  }

  showError(): boolean {
    return Boolean(this.formControl && this.formControl.errors && this.formControl.dirty);
  }

}
